@if (Vendor && ProposalRequest) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <h2>Bid Details - {{ Vendor.legalName }}</h2>
      </div>
    </div>
    <div class="row g-3 py-3">
      <div class="col">
        <app-display-card
          [panelHeight]="'fit'"
          [innerPanel]="true"
          [header]="'Bid - ' + ProposalRequest.name"
          [headerPosition]="'left'"
        >
          @if (ProposalRequest.Address && ProposalRequest.Address.isMailing) {
            <div class="row">
              <div class="col">
                <h6>Work Location Details</h6>
                <hr class="mt-1" />
                <div class="row align-items-center">
                  <div class="col-2">
                    <label>Address: </label>
                  </div>
                  <div class="col-10">
                    <p class="m-0">{{ ProposalRequest.Address.address1 }}</p>
                  </div>
                </div>
                <div class="row align-items-center">
                  <div class="col-2">
                    <label>Address2: </label>
                  </div>
                  <div class="col-10">
                    <p class="m-0">{{ ProposalRequest.Address.address2 }}</p>
                  </div>
                </div>
                <div class="row align-items-center">
                  <div class="col-3">
                    <div class="row align-items-center">
                      <div class="col-4">
                        <label>City: </label>
                      </div>
                      <div class="col-6">
                        <p class="m-0">{{ ProposalRequest.Address.city }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="row align-items-center">
                      <div class="col-5">
                        <label>State: </label>
                      </div>
                      <div class="col-6">
                        <p class="m-0">{{ ProposalRequest.Address.state }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="row align-items-center">
                      <div class="col-4">
                        <label>Zip: </label>
                      </div>
                      <div class="col-6">
                        <p class="m-0">{{ ProposalRequest.Address.zip }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-lg-12"
                [ngClass]="{
                  'col-xl-6 ps-xl-0': !ProposalRequestVendor?.Proposal
                }"
              >
                <div class="row">
                  <div
                    class="col"
                    [ngClass]="{
                      'ps-xl-0': !ProposalRequestVendor?.Proposal,
                      'pt-4': $safeNavigationMigration(
                        ProposalRequestVendor?.Proposal
                      )
                    }"
                  >
                    <h6>Contact Details</h6>
                    <hr class="mt-1" />
                    <div class="row">
                      <div class="col-6">
                        <div class="row align-items-center">
                          <div class="col-5">
                            <label>First Name: </label>
                          </div>
                          <div class="col-7">
                            <p class="m-0">
                              {{ ProposalRequest.contactFirstName }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row align-items-center">
                          <div class="col-5">
                            <label>Last Name: </label>
                          </div>
                          <div class="col-7">
                            <p class="m-0">
                              {{ ProposalRequest.contactLastName }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row align-items-center">
                          <div class="col-5">
                            <label>Mobile Phone: </label>
                          </div>
                          <div class="col-7">
                            <p class="m-0">
                              {{ ProposalRequest.contactPhone }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="row align-items-center">
                          <div class="col-5">
                            <label>Work Phone: </label>
                          </div>
                          <div class="col-7">
                            <p class="m-0">
                              {{ ProposalRequest.contactPhone2 }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="row align-items-center">
                          <div class="col-5">
                            <label>Email: </label>
                          </div>
                          <div class="col-7">
                            <p class="m-0">
                              {{ ProposalRequest.contactEmail }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="row pt-4">
            <div class="col">
              <h6>Instructions</h6>
              <hr class="mt-1" />
              <div class="row align-items-center">
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label>Due Date: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ ProposalRequest.dueDate | date }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label>Reminder Date: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">
                        {{ ProposalRequest.reminderDate | date }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row align-items-center">
                    <div class="col-6">
                      <label>Start Date: </label>
                    </div>
                    <div class="col-6">
                      <p class="m-0">{{ ProposalRequest.startDate | date }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                @for (item of proposalRequestLineItems | keyvalue; track item) {
                  @if (item.value) {
                    <div class="col-4">
                      <div class="row align-items-center">
                        <div class="col-6">
                          <label>{{ item.key }} </label>
                        </div>
                        <div class="col-6">
                          <p class="m-0">{{ item.value }}</p>
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
              <div class="row">
                <div class="col">
                  <div class="d-inline">
                    <label>Instructions: </label>
                    {{ ProposalRequest.instructions }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (proposalRequestFiles.length > 0) {
            <div class="row pt-4">
              <div class="col">
                <h6>Documents</h6>
                <hr class="mt-1" />
                <div class="row">
                  <div class="col">
                    @for (file of proposalRequestFiles; track file) {
                      @if (file && file.id) {
                        <div class="row">
                          <div class="col">
                            <label>{{ file.filename }}</label>
                          </div>
                          <div class="col-4">
                            <button
                              class="btn btn-primary"
                              (click)="
                                downloadFile(file, 'ProposalRequestFile')
                              "
                            >
                              Download
                            </button>
                          </div>
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </app-display-card>
      </div>
      @if (ProposalRequestVendor && ProposalRequestVendor.Proposal) {
        <div class="col-lg-12 col-xl-6">
          <div class="row g-3">
            <div class="col">
              <app-display-card
                [panelHeight]="'fit'"
                [header]="'Proposal'"
                [headerPosition]="'left'"
                [innerPanel]="true"
              >
                <div class="row">
                  <div class="col">
                    <div class="row align-items-center">
                      <div class="col-6">
                        <label>Start Date: </label>
                      </div>
                      <div class="col-6">
                        <p class="m-0">
                          {{
                            ProposalRequestVendor.Proposal.workStartDate | date
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="row align-items-center">
                      <div class="col-6">
                        <label>Finish Date: </label>
                      </div>
                      <div class="col-6">
                        <p class="m-0">
                          {{
                            ProposalRequestVendor.Proposal.workFinishDate | date
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row align-items-center">
                  @for (item of proposalLineItems; track item) {
                    @if (item.value) {
                      <div class="col">
                        <div class="row align-items-center">
                          <div class="col-6">
                            <label>{{ item.label }} </label>
                          </div>
                          <div class="col-6">
                            <p class="m-0">{{ item.value | currency }}</p>
                          </div>
                        </div>
                      </div>
                    }
                  }
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="row align-items-center">
                      <div class="col-6">
                        <label>Total Price: </label>
                      </div>
                      <div class="col-6">
                        <p class="m-0">
                          {{
                            ProposalRequestVendor.Proposal.totalPrice | currency
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="d-inline">
                      <label>Comments: </label>
                      {{ ProposalRequestVendor.Proposal.comments }}
                    </div>
                  </div>
                </div>
                @if (proposalFiles.length > 0) {
                  <div class="row pt-4">
                    <div class="col">
                      <h6>Documents</h6>
                      <hr class="mt-1" />
                      <div class="row">
                        <div class="col">
                          @for (file of proposalFiles; track file) {
                            @if (file && file.id) {
                              <div class="row">
                                <div class="col">
                                  <label>{{ file.filename }}</label>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-primary"
                                    (click)="downloadFile(file, 'ProposalFile')"
                                  >
                                    Download
                                  </button>
                                </div>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </app-display-card>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
